import { InsightsState } from '../schema';
import {
  SET_INSIGHTS_PATTERNS,
  SET_INSIGHTS_LOADING,
  SET_INSIGHTS_ERROR,
} from '../middleware';

const initialState: InsightsState = {
  patterns: [],
  loading: false,
  error: null,
};

const insightsReducer = (state = initialState, action: any): InsightsState => {
  switch (action.type) {
    case SET_INSIGHTS_LOADING:
      return {
        ...state,
        loading: action.payload.loading,
      };
    case SET_INSIGHTS_PATTERNS:
      return {
        ...state,
        patterns: action.payload.patterns,
        loading: false,
        error: null,
      };
    case SET_INSIGHTS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default insightsReducer;
